"use client";

import { userTracker } from "@/lib/user-tracking";

export interface TrackAssessmentEventInput {
  userId?: string | null;
  status: "created" | "skipped" | "failed";
  requestId?: string | null;
  triggerSource?: string | null;
  latencyMs?: number | null;
  errorCode?: string | null;
  remainingTurns?: number | null;
  cooldownMs?: number | null;
}

export function trackAssessmentEvent(input: TrackAssessmentEventInput) {
  if (typeof window === "undefined") return;
  const payload = {
    ...input,
    timestamp: new Date().toISOString(),
  };

  try {
    void userTracker.trackCustomEvent("assessment_update", payload);
  } catch (error) {
    console.debug("[assessment-tracking] fallback", error);
  }

  if (process.env.NODE_ENV !== "production") {
    console.info("[assessment_event]", payload);
  }
}
